<template>
  <div class="aspect-[7/13] md:aspect-auto no-scroll">
    <video
      ref="videoElement"
      :src="videoInstruction"
      autoplay
      class="w-full h-full object-cover"
      loop
      muted
      playsinline
      @error="handleVideoError"
      @loadedmetadata="getVideoDuration"
    ></video>
  </div>
</template>

<script setup>
import { onBeforeMount, onMounted, ref, watchEffect } from 'vue'
import { useI18n } from 'vue-i18n'
import { onWeChatReady } from '@/utils/useWeChatSDK.js'

defineProps({
  isHybrid: Boolean
})
const emits = defineEmits(['videoDuration'])

const videoInstructions = {
  en: () => import('../assets/video-instruction/PA-instruction-EN.mp4'),
  de: () => import('../assets/video-instruction/PA-instruction-DE.mp4'),
  fa: () => import('../assets/video-instruction/PA-instruction-FA.mp4'),
  fr: () => import('../assets/video-instruction/PA-instruction-FR.mp4'),
  hi: () => import('../assets/video-instruction/PA-instruction-HI.mp4'),
  es: () => import('../assets/video-instruction/PA-instruction-ES.mp4'),
  it: () => import('../assets/video-instruction/PA-instruction-IT.mp4'),
  id: () => import('../assets/video-instruction/PA-instruction-ID.mp4'),
  ja: () => import('../assets/video-instruction/PA-instruction-JA.mp4'),
  ko: () => import('../assets/video-instruction/PA-instruction-KO.mp4'),
  nl: () => import('../assets/video-instruction/PA-instruction-NL.mp4'),
  th: () => import('../assets/video-instruction/PA-instruction-TH.mp4'),
  zh: () => import('../assets/video-instruction/PA-instruction-ZH.mp4'),
  tw: () => import('../assets/video-instruction/PA-instruction-TW.mp4'),
  vi: () => import('../assets/video-instruction/PA-instruction-VI.mp4')
}

const { locale } = useI18n()
const videoInstruction = ref(null)
const videoElement = ref(null)

const loadVideoForLocale = async () => {
  const lang = locale.value.toLowerCase()
  const loadVideoInstruction = videoInstructions[lang] || videoInstructions.en
  videoInstruction.value = (await loadVideoInstruction()).default
}

const playVideo = () => {
  if (videoElement.value) {
    videoElement.value.play().catch((error) => {
      console.error('Video Instruction failed to play:', error.message)
    })
  }
}

onMounted(() => {
  onWeChatReady(playVideo)
})

onBeforeMount(() => {
  loadVideoForLocale()
})

watchEffect(() => {
  loadVideoForLocale()
})

const getVideoDuration = (e) => {
  const videoElement = e.target
  const duration = Math.round(videoElement.duration)
  emits('videoDuration', duration)
}

const handleVideoError = (e) => {
  console.error('Video failed to load:', e.target.src)
}
</script>
